import { render, staticRenderFns } from "./BaseBevel.vue?vue&type=template&id=79435261&scoped=true&"
import script from "./BaseBevel.vue?vue&type=script&lang=js&"
export * from "./BaseBevel.vue?vue&type=script&lang=js&"
import style0 from "./BaseBevel.vue?vue&type=style&index=0&id=79435261&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79435261",
  null
  
)

export default component.exports